import ScreenshotOverlay from './screenshot-overlay';

export default class ScreenshotOverlayDemo extends ScreenshotOverlay {
    constructor(screenshot, onClick) {
        super(screenshot, onClick);

        this.text =
            "<b>Good job!</b> Submit a demo request to know how boards boosts your team's operational excellence.";
        this.buttonText = 'Request a <i>demo</i>';
        this.buttonColor = 'blue';
    }
}



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/screenshots/screenshot-overlay-demo.js